import { IPropertySelection } from "@origin-digital/event-dispatcher";

export const groupBy = <T>(
  array: T[],
  getKey: (value: T) => string | undefined
): Record<string, T[]> =>
  array.reduce((accumulator: Record<string, T[]>, item) => {
    const key = getKey(item);
    if (isPresent(key)) {
      const existingGroup = accumulator[key];
      if (existingGroup) {
        existingGroup.push(item);
      } else {
        accumulator[key] = [item];
      }
    }
    return accumulator;
  }, {}) ?? {};

export const getFirst = <T>(array: T[]): T | undefined =>
  array?.[0] ?? undefined;

export const isPresent = <T>(value: T | null | undefined): value is T => {
  return value !== null && value !== undefined;
};

export const copyPropertySelection = (
  propertySelection: IPropertySelection | null
): IPropertySelection | null => {
  if (propertySelection === null) {
    return null;
  }
  return {
    ...propertySelection,
    accountServices: propertySelection.accountServices.map(
      (accountService) => ({ ...accountService })
    ),
  };
};
